<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!verificarPermissao('PERM_INSERIR_CLIENTE')">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="verificarPermissao('PERM_INSERIR_CLIENTE')">
			<form (keypress)="ocultarMensagem()" (ngSubmit)="f.form.valid && salvar()" #f="ngForm" name="form"
				novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="col-12 md:col-12">
							<h5>Dados Pessoais</h5>
						</div>
						<div class="field col-12 md:col-5">
							<label htmlFor="nome">Nome*</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text"
								(input)="validarNome($event)" pInputText placeholder="Digite o nome e sobrenome"
								name="nome" ngModel #nome="ngModel" required [(ngModel)]="cliente.nome" />
							<div *ngIf="nome.hasError('required') && nome.touched" class="alerta">
								<small>Campo obrigatório</small>
							</div>
							<div *ngIf="!nome.hasError('required') && !temDuasPalavras" class="alerta">
								<small>É necessário inserir nome e sobrenome</small>
							</div>

						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="apelido">Apelido</label>
							<input oninput="this.value = this.value.toUpperCase();" type="text" pInputText
								placeholder="Digite o apelido" name="apelido" ngModel #nome="ngModel"
								[(ngModel)]="cliente.apelido" />
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="cpf">CPF</label>
							<p-inputMask mask="999.999.999-99" [unmask]="true" type="text" placeholder="000.000.000-00"
								name="cpf" ngModel #cpf="ngModel" (onBlur)="buscarClientePorCpf()"
								[(ngModel)]="cliente.cpf"> </p-inputMask>
							<div *ngIf="clienteCpfEncontrado" class="alerta">
								<small>CPF Informado já existe</small>
							</div>
						</div>

						<div class="field col-12 md:col-2">
							<label htmlFor="aniversario">Aniversário</label>
							<p-inputMask mask="99/99" type="text" placeholder="DD/MM" name="aniversario" ngModel
								#aniversario="ngModel" (onBlur)="validarAniversario()" [(ngModel)]="cliente.aniversario"> </p-inputMask>
							<div *ngIf="!dataValida" class="alerta">
								<small>Data inválida</small>
							</div>
						</div>
						<div class="field col-12 md:col-4">
							<label htmlFor="email">E-mail</label>
							<input pInputText type="email" placeholder="seuemail@mail.com" name="email" ngModel
								email="true" #email="ngModel" [(ngModel)]="cliente.email"/>
							<div *ngIf="email.hasError('email')" class="alerta">
								<small>Digite um e-mail válido</small>
							</div>
						</div>


						<div class="col-12 md:col-12">
							<h5>Endereço</h5>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="cep">CEP</label>
							<p-inputMask mask="99999-999" [unmask]="true" placeholder="00000-000" name="cep" ngModel
								#cep="ngModel" (onBlur)="consultarCep()" [(ngModel)]="cliente.cep"> </p-inputMask>
						</div>
						<div class="field col-12 md:col-6">
							<label htmlFor="logradouro">Logradouro</label>
							<input #inputLogradouro oninput="this.value = this.value.toUpperCase();" pInputText
								type="text" name="logradouro" ngModel #logradouro="ngModel"
								[(ngModel)]="cliente.logradouro" (ngModelChange)="camposPreenchendo()"
								[autofocus]="focoCampo" />
							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>Logradouro não encontrado</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="bairro">Bairro</label>
							<input pInputText type="text" name="bairro" ngModel
								oninput="this.value = this.value.toUpperCase();" (ngModelChange)="camposPreenchendo()"
								[(ngModel)]="cliente.bairro" #bairro="ngModel" />
							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>Bairro não encontrado</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="numeroEndereco">Número</label>
							<input pInputText type="text" name="numeroEndereco" ngModel #numeroEndereco="ngModel"
								[disabled]="bloqueiaNumeroEComplemento" [(ngModel)]="cliente.numeroEndereco"/>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="complementoEndereco">Complemento</label>
							<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
								name="complementoEndereco" ngModel #complementoEndereco="ngModel" [(ngModel)]="cliente.complementoEndereco"
								[disabled]="bloqueiaNumeroEComplemento" />
						</div>
						<div class="field col-12 md:col-2" *ngIf="!trocarCamposEndereco">
							<label htmlFor="uf">Estado</label>
							<p-dropdown [options]="listaUfs" optionLabel="siglaUf" optionValue="siglaUf" [editable]="true" [filter]="true"
								emptyFilterMessage="Nenhum registro" (onChange)="listarMunicipios()" placeholder="UF"
								name="uf" ngModel #uf="ngModel" [(ngModel)]="cliente.uf"
								[disabled]="bloquearCamposEndereco"></p-dropdown>

							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>UF não encontrado</small>
							</div>
						</div>
						<div class="field col-12 md:col-2" *ngIf="trocarCamposEndereco">
							<label htmlFor="uf">Estado</label>
							<input pInputText type="text" ngModel name="ufs" [(ngModel)]="cliente.uf"
								#uf="ngModel" [readonly]="bloquearCamposEndereco" />
						</div>

						<div class="field col-12 md:col-7" *ngIf="!trocarCamposEndereco">
							<label htmlFor="cidade">Cidade</label>
							<p-dropdown [options]="listaMunicipios" [disabled]="!isUfSelecionada"
								optionLabel="descricao" optionValue="descricao" [editable]="true" [filter]="true"
								emptyFilterMessage="Nenhum registro" placeholder="Selecione a Cidade" name="cidade"
								ngModel #cidade="ngModel" [(ngModel)]="cliente.cidade"></p-dropdown>
							<div *ngIf="exibirMensagemCep" class="alerta">
								<small>Cidade não encontrada</small>
							</div>
						</div>

						<div class="field col-12 md:col-3" *ngIf="trocarCamposEndereco">
							<label htmlFor="cidade">Cidade</label>
							<input pInputText type="text" name="cidade" ngModel [(ngModel)]="cliente.cidade"
								#cidade="ngModel" [readonly]="bloquearCamposEndereco" />
						</div>

						<div class="col-12 md:col-12">
							<h5>Indicador</h5>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="indicadorCliente">Indicador Cliente</label>
							<p-dropdown [options]="indicadoresClientes" optionLabel="descricao" optionValue="descricao" [filter]="true"
								emptyFilterMessage="Nenhum registro" [(ngModel)]="cliente.indicadorCliente"
								placeholder="Não informado" name="indicadorCliente"></p-dropdown>
						</div>
						<div class="col-12 md:col-12">
							<h5>Contatos</h5>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="numero">Número</label>
							<p-inputMask mask="(99)99999-9999" placeholder="(99)99999-9999" name="numero"
								[(ngModel)]="contatoCliente.numero"></p-inputMask>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="identificacao">Identificação</label>
							<input oninput="this.value = this.value.toUpperCase();" pInputText type="text"
								name="identificacao" placeholder="Descrição"
								[(ngModel)]="contatoCliente.identificacao" />
						</div>

						<div class="field col-12 md:col-1">
							<label for="principal">Principal?</label>
							<br />
							<p-inputSwitch name="principal" [(ngModel)]="contatoCliente.principal"></p-inputSwitch>

						</div>
						<div class="field col-12 md:col-2">
							<button type="button" pButton icon="pi pi-check" class="p-button-success mt-5"
								(click)="adicionarContato()"></button>
						</div>
						<div class="field col-12 md:col-12">
							<p-table #dt1 [value]="listaContatos" dataKey="id" [rows]="10" [rowHover]="true"
								styleClass="p-datatable-gridlines" [paginator]="false" responsiveLayout="scroll"
								styleClass=" p-datatable-sm">

								<ng-template pTemplate="header">
									<tr>
										<th>
											<div class="flex justify-content-between align-items-center">
												URL
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Identificador
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Principal
											</div>
										</th>
										<th>
											<div class="flex justify-content-between align-items-center">
												Ações
											</div>
										</th>
									</tr>
								</ng-template>
								<ng-template pTemplate="body" let-item>
									<tr>
										<td>
											{{item.numero}}
										</td>
										<td>
											<label>{{item.identificacao ? item.identificacao : 'Não informado'}}</label>
										</td>
										<td>
											<label>{{item.principal ? 'Sim' : 'Não'}}</label>
										</td>
										<td>
											<button [disabled]="mostrarBotoes()" pButton pRipple pTooltip="Editar"
												type="button" icon="pi pi-pencil" class="p-button-success mr-2 mb-2"
												(click)="editarContato(item)"></button>
											<button pButton pRipple pTooltip="Excluir" type="button" icon="pi pi-trash"
												class="p-button-danger mr-2 mb-2 sm"
												(click)="removerContato(item)"></button>
										</td>

									</tr>
								</ng-template>
								<ng-template pTemplate="emptymessage">
									<tr>
										<td colspan="7">Nenhum contato inserido.</td>
									</tr>
								</ng-template>
							</p-table>
						</div>

					</div>
					<div class="p-fluid p-formgrid grid justify-content-between">
						<div class="col-12 md:col-4">
							<button *ngIf="!progressoRequisicao else exibirBotaoFalso" type="submit" pButton
								icon="pi pi-check" label="Salvar"
								class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid || !temDuasPalavras
									 || clienteCpfEncontrado || !dataValida">
							</button>
							<ng-template #exibirBotaoFalso>
								<button type="submit" pButton icon="pi pi-spin pi-spinner" label="Salvar"
									class="p-button-outlined p-button-success md:w-9rem" disabled></button>
							</ng-template>
						</div>
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/cliente"></button>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>